export default "__VITE_ASSET__CTnmOb5o__"